const pad2 = (n) => String(n).padStart(2, '0');

// Floating local time format (no timezone suffix) works well for simple calendar imports.
const formatIcsDateTimeLocal = (date) => {
  const d = new Date(date);
  return (
    `${d.getFullYear()}${pad2(d.getMonth() + 1)}${pad2(d.getDate())}` +
    `T${pad2(d.getHours())}${pad2(d.getMinutes())}${pad2(d.getSeconds())}`
  );
};

const escapeIcsText = (value) =>
  String(value || '')
    .replace(/\\/g, '\\\\')
    .replace(/\n/g, '\\n')
    .replace(/,/g, '\\,')
    .replace(/;/g, '\\;');

export const getNextWeeklyDate = (baseDate, hour = 9, minute = 0) => {
  const base = baseDate ? new Date(baseDate) : new Date();
  const next = new Date(base);
  next.setDate(next.getDate() + 7);
  next.setHours(hour, minute, 0, 0);
  return next;
};

export const downloadWeeklyReminderIcs = ({
  title,
  description,
  startDate,
  durationMinutes = 15,
  filename = 'founderdna-weekly-check-in.ics',
}) => {
  const start = new Date(startDate);
  const end = new Date(start);
  end.setMinutes(end.getMinutes() + durationMinutes);

  const dtstamp = formatIcsDateTimeLocal(new Date());
  const dtstart = formatIcsDateTimeLocal(start);
  const dtend = formatIcsDateTimeLocal(end);
  const uid = `founderdna-${Date.now()}@local`;

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//FounderDNA//Weekly Check In//EN',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART:${dtstart}`,
    `DTEND:${dtend}`,
    `SUMMARY:${escapeIcsText(title)}`,
    `DESCRIPTION:${escapeIcsText(description)}`,
    'RRULE:FREQ=WEEKLY;INTERVAL=1',
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  const blob = new Blob([lines.join('\r\n')], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
};

